const key = process.env.REACT_APP_AES_GCM_KEY; // 32 bytes

const encoder = new TextEncoder();
const decoder = new TextDecoder();

const keyBuffer = encoder.encode(key);

export const decryptURL = async (encryptedURL: string) => {
  // Split IV and ciphertext
  const [ivB64, dataB64] = encryptedURL.split("::");

  // Base64 → Uint8Array
  const ivBuffer = Uint8Array.from(atob(ivB64), (c) => c.charCodeAt(0));

  const encryptedBuffer = Uint8Array.from(atob(dataB64), (c) =>
    c.charCodeAt(0)
  );

  // Convert Key from ArrayBuffer to CryptoKey object
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  // Decryption
  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: ivBuffer },
    cryptoKey,
    encryptedBuffer
  );

  // Decode the decrypted data to a string
  return decoder.decode(decryptedBuffer);
};
